export const DEFAULT_MAX_LENGTH = Infinity;

export enum BREADCRUMBS_SIZES {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}
